const Resources = {

    table_headers: [
        {
            text: 'Name',
            align: 'start',
            value: 'name',
            type: 'link',
            sort_type: 'text',
        },
        {
            text: 'Abbreviation',
            value: 'abbreviation',
            sort_type: 'text',
        },
        {
            text: 'Level Counter',
            value: 'level_counter',
            sort_type: 'number'
        },
        {
            text: 'Area Counter',
            value: 'area_counter',
            sort_type: 'number'
        },
        {
            text: 'Room Counter',
            value: 'room_counter',
            type: 'text_link_action',
            sort_type: 'number'
        },
        {
            text: 'Sq. Footage',
            value: 'sq_footage',
            sort_type: 'number',
        },
    ],

    breadcrumb: [
        {
            name: "Home",
            href: "/",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Buildings",
            href: "/buildings",
            arrow: "",
        },
    ],


    table_headers_test: [
        {
            text: "Report Number",
            align: "start",
            value: "ReportNumber"
        },
        {
            text: "Description",
            value: "rp_descr"
        },
        {
            text: "File",
            value: "rp_file"
        },
        {
            text: "Name",
            value: "rp_name"
        },
    ],
    
    excel_file_headers: {
        'Name': 'name',
        'Abbreviation': 'abbreviation',
    },

    empty_format_data: [
        {
            name: '',
            abbreviation: '',
        },
    ],

    helps: [
        {
            label: '¿How to add a Building?', 
            instruction: `https://scribehow.com/embed/Add_a_Building__dbaTKlO-SkyfH3agaMuf5w?as=scrollable`
        },
        {
            label: '¿How to delete Buildings?', 
            instruction: `https://scribehow.com/embed/How_To_Delete_Buildings___vFG86ElSt2Mm8M7xfl2ug?as=scrollable`
        },
    ]
}

export default Resources;